export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../assets/images/about/about-banner.jpg'),
        title: 'グローバルITサービス企業',
        description: 'MaesInfoは中国と米国に拠点を持ち、グローバルなお客様に24時間体制でサービスを提供します。',
        component: ''
      }
  ],
  story:{
   title: '私たちの物語',
   description: `<span class="img" style="background:url(`+require('../../assets/images/about/about-pic-1.jpg')+`)"></span>
   <p>MaesInfoは2005年に設立され、ITアウトソーシング、ソフトウェア開発、ITソリューション、BPOサービスをグローバルに提供する主要プロバイダーの一つです。MaesInfoは中国と米国に拠点を持ち、製造業、金融サービス、ヘルスケア、小売・卸売分野を含む多くの大手企業と長期的なパートナーシップを築いてきました。</p>
   <p>当社チームはビジネスアナリスト、アーキテクト、プロセスコンサルタント、UIデザイナー、ソフトウェアエンジニア、DBA、QA/QCエンジニアで構成され、多様なプログラミング言語、フレームワーク、業界知識を有しています。</p>`
  },
  otherItem:[
    {
      title: 'ビジョン',
      imgUrl: require('../../assets/images/about/about-pic-2.jpg'),
      description: 'MaesInfoは高品質なITアウトソーシングと価値あるBPOサービスを提供する、中国を代表するソフトウェアアウトソーサーになることを目指しています。',
      component: ''
    },
    {
      title: 'ミッション',
      imgUrl: require('../../assets/images/about/about-pic-3.jpg'),
      description: '専門性と努力を通じて、世界中のお客様に最高品質のITサービスを提供することを目指します。'
    },
    {
      title: '企業文化',
      imgUrl: require('../../assets/images/about/about-pic-4.jpg'),
      description: '人材と研修：英語ネイティブスタッフを擁し、顧客と開発者間のコミュニケーションを促進します。全スタッフに対する言語研修を実施しています。'
    },
    {
      title: 'リーダーシップ',
      imgUrl: require('../../assets/images/about/about-pic-3.jpg'),
      description: 'MaesInfoの経営陣はグローバルブランドでの実務経験を有し、起業家精神を持って挑戦を奨励し、世界中の同僚とスキルと経験を共有します。'
    },
    {
      title: '当社の強み',
      imgUrl: require('../../assets/images/about/about-pic-5.jpg'),
      description: 'MaesInfoはあらゆる規模の企業に対してオフショアITアウトソーシング（ITO）、ビジネスプロセスアウトソーシング（BPO）、ソフトウェア開発を提供します。高品質かつ低コストの運用モデルにより、生産性と予測可能性を向上させながらコスト削減を支援します。'
    }
  ]

}
